import { type PortableTextMarkComponentProps } from '@portabletext/react'

import { SanityLink } from '@data/sanity/queries/types/content'

import CustomLink from '@components/link'

type LinkValue = SanityLink & {
  _type: 'link'
}

const Link = ({
  value,
  children,
}: PortableTextMarkComponentProps<LinkValue>) => {
  if (!value) {
    return null
  }

  return <CustomLink link={value}>{children}</CustomLink>
}

export default Link
